import { component } from 'picoapp';
import { getSizedImageUrl, imageSize } from '@/lib/images.js';
import { formatMoney } from '@/lib/currency.js';
import { addCustomerNote } from '@/lib/cart.js';
import app from '@/app.js';
import { gsap } from 'gsap';

const EXPANDED_CLASS = 'is-expanded';

const X =
  '<svg class="icon icon-close" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="11.859" height="11.859" viewBox="0 0 11.859 11.859"><path d="M10.797 11.856 0 1.06 1.06 0l10.8 10.8Z"/><path d="m1.061 11.859-1.06-1.06 10.8-10.8 1.061 1.061Z"/></svg>';

const caretUp = '<svg class="icon icon-caret-up" xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7"> <path d="M6 1a1 1 0 0 1 2 0l4 4a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2Z" fill="currentColor"/></svg>';

const caretDown = '<svg class="icon icon-caret-down" xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7"> <path d="M6 1a1 1 0 0 1 2 0l4 4a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2Z" transform="rotate(180 7 4)" fill="currentColor"/></svg>';

const loader = '<div class="o-loader-2"><div></div><div></div><div></div></div>';

function createItem({
  variant_id: id,
  properties: properties,
  product_title: title,
  product_type: type,
  line_price: price,
  variant_title: variant,
  image,
  url,
  quantity,
  ...item
}) {
  const img = image
    ? getSizedImageUrl(
      image.replace('.' + imageSize(image), ''),
      '200x'
    )
    : 'https://cdn.shopify.com/s/files/1/0565/3099/3330/files/product-placeholder.png?v=1620222937';

  return `
    <div class="c-cart-drawer__item c-product" data-component="cartDrawerItem" data-id=${id}>
      
      <a class="flex-none" href="${url}">
        <span class="sr-only">${title}</span>
        <img class="c-product__image" src="${img}" alt="" role="img" aria-hidden/>
      </a>

      <div class="flex-1">
        <div class="flex justify-between align-start">
          <div>
            <a class="c-product__title" href="${url}">
              ${title}
            </a>
            <p class="c-product__type">${type}</p>
          </div>
          <button class="c-product__remove js-remove-item">${X}</button>
        </div>
        
        ${variant ? `<div class="c-product__variant">${variant.split(':')[0]}</div>` : ''}

        ${properties ? `<ul class="c-product__properties">${listProperties(properties)}</ul>` : ''}

        <div class="flex align-center justify-between">
          <div class="c-product__price">
            ${formatMoney(price)}
          </div>

          <div class="c-product__quantity flex align-center">
            <div>
              QTY <input class="c-basket__product-quantity js-single-quantity" id="quantity${id}" type="number" min=0 max=99 value=${quantity}>
              </span>&nbsp;
            </div>
            <div class="flex flex-column text-small line-height-normal">
              <button type="button" class="js-add-single">${caretUp}</button>
              <button type="button" class="js-remove-single">${caretDown}</button>
            </div>
          </div>
          
        </div>
      </div>

    </div>
  `;
}

function listProperties(properties) {
  let html = '';
  for (const property in properties) {
    html += `<li>${property}: ${properties[property]}</li>`;
  }
  return html;
}

function renderItems(items) {
  return items.length > 0
    ? items.reduce((markup, item) => {
      markup += createItem(item);
      return markup;
    }, '')
    : '<div class="c-cart-drawer__is-empty"><p>Your basket is empty</p></div>';
}

export default component((node, ctx) => {
  const overlay = node.querySelector('.js-overlay');
  const closeButton = node.querySelector('.js-close');
  const subtotal = node.querySelector('.js-subtotal');
  const itemsRoot = node.querySelector('.js-items');
  const checkoutButton = node.querySelector('.js-checkout-button');
  const loading = itemsRoot.innerHTML;
  const toggleCartNote = node.querySelector('.js-toggle-cart-note');
  const cartNoteContents = node.querySelector('.js-cart-note-contents');
  const chevron = node.querySelector('.icon-chevron-down');
  const cartNoteInput = node.querySelector('.js-cart-note-input');
  const render = (cart) => {
    itemsRoot.innerHTML = renderItems(cart.items);
    subtotal.innerHTML = formatMoney(cart.total_price);
  };

  const open = (cart) => {
    node.classList.add('is-active');
    document.body.classList.add('no-scroll');
    itemsRoot.innerHTML = loading;
    setTimeout(() => {
      node.classList.add('is-visible');
      setTimeout(render(cart), 10);
      app.mount();
    }, 50);
  };

  const close = () => {
    node.classList.remove('is-visible');
    document.body.classList.remove('no-scroll');
    setTimeout(() => {
      node.classList.remove('is-active');
      app.hydrate({ cartOpen: false });
    }, 400);
  };

  const hideCartNote = () => {
    gsap.to(cartNoteContents, { height: 0 });
    gsap.to(chevron, { scaleY: 1, duration: 0.1 });
  };

  const showCartNote = () => {
    gsap.to(cartNoteContents, { height: 'auto' });
    gsap.to(chevron, { scaleY: -1, duration: 0.1 });
  };

  function toggleCartNoteVisibility() {
    if (this.classList.contains(EXPANDED_CLASS)) {
      this.classList.remove(EXPANDED_CLASS);
      hideCartNote();
    } else {
      this.classList.add(EXPANDED_CLASS);
      showCartNote();
    }
  }

  hideCartNote();
  render(ctx.getState().cart);

  overlay.addEventListener('click', close);
  closeButton.addEventListener('click', close);
  toggleCartNote.addEventListener('click', toggleCartNoteVisibility);

  cartNoteInput.addEventListener('blur', () => {
    addCustomerNote(cartNoteInput.value);
  });

  checkoutButton.addEventListener('click', () => {
    $(checkoutButton).html(loader);
  });

  ctx.on('cart:toggle', ({ cart, cartOpen }) => {
    cartOpen && open(cart);
  });

  ctx.on('cart:updated', () => {
    render(ctx.getState().cart);
    app.mount();
  });
});
